<template>
  <div class="location-tooltip"
       :class="tooltipClasses"
       @click="openLocationConfigureScreen">
    <div class="location-status">
      <location-status class="status"
                       :child="child" />
    </div>

    <div class="tooltip-content">
      <div>
        {{ tooltipText }}
      </div>

      <div class="meta-info">
        <component :is="getPlatformIcon"
                   width="16"
                   height="16"
                   iconColor="#fff"
                   class="platform-icon" />

        <div>
          {{ primaryDevice.name }}
        </div>
      </div>
    </div>

		<div class="pin"></div>
  </div>
</template>

<script>
  import LocationStatus from '@/components/Common/LocationStatus'
  import platformIcons from '@/constants/platformIcons.js'

  export default {
    components: {
      LocationStatus
    },

    props: {
      child: {
        type: Object,
        required: true
      }
    },

    methods: {
      openLocationConfigureScreen() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'configure-location',
            params: {
              mode: this.child.latest_location.named_location_id ? 'update' : 'create',
              locationId: this.child.latest_location.named_location_id,
              locationFromHistory: this.child.latest_location
            }
          })

          return
        }

        this.showModal('geofence-configure', {
          mode: this.child.latest_location.named_location_id ? 'update' : 'create',
          id: this.child.latest_location.named_location_id,
          locationFromHistory: this.child.latest_location
        })
      }
    },

    computed: {
      ...mapGetters('geofence', {
        getNamedLocationById: 'getNamedLocationById',
      }),

      primaryDevice() {
        return this.child.devices.find(device => device.id === this.child.primary_device_id)
      },

      namedLocation() {
        return this.getNamedLocationById(this.child.latest_location.named_location_id)
      },

      address() {
        const location = this.child.latest_location

        return location.address ? location.address : `${location.latitude} ${location.longitude}`
      },

      tooltipText() {
        if (this.child.latest_location.named_location_id && this.namedLocation) {
          return this.namedLocation.name
        }

        return this.address
      },

      getPlatformIcon() {
        if (platformIcons[this.primaryDevice.platform]) {
          return platformIcons[this.primaryDevice.platform]
        }

        return platformIcons['ios']
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      tooltipClasses() {
        return {
          'location-tooltip-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .location-tooltip {
    display: flex;
    flex-direction: column;

    height: auto;
    width: 250px;
    position: relative;
    z-index: 999;

    color: #fff;
    border: 1px solid #fff;
    border-radius: 6px;

    .location-status {
      height: 38px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding: 12px;
      background: #fff;

      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      .status {
        color: map-get($colors, primary);
        justify-content: space-between;
      }
    }

    .tooltip-content {
      padding: 10px 12px 0 12px;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 999;
      background: map-get($colors, primary);
      width: 100%;
      height: 100%; 

      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px
    }

    .meta-info {
      display: flex;
      margin: 10px 0;

      .platform-icon {
        width: 16px;
        height: 16px;

        margin-right: 5px;
        position: relative;
        bottom: -1px;
      }
    }

    .pin {
      background:map-get($colors, primary);
      width: 12px;
      height: 12px;
      position: absolute;
      left: calc(50% - 6px);
      bottom: -6px;
      transform: rotate(45deg);
      border-bottom: 1px solid #fff;
      border-right: 1px solid #fff;
      z-index: 1;
    }
  }

  .location-tooltip-mobile {
    width: 170px;

    .location-status {
      height: 24px;
      padding: 6px;

      .status {
        font-size: 10px;
      }
    }

    .tooltip-content {
      padding: 5px 6px 0 6px;
      font-size: 10px;
    }

    .meta-info {
      margin: 5px 0;

      .platform-icon {
        bottom: 2px;
      }
    }
  }
</style>